import { __decorate, __param } from 'tslib';
import { EventEmitter, Inject, Input, Output, HostBinding, Component, ChangeDetectionStrategy, Optional, Self, ChangeDetectorRef, ViewChild, forwardRef, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TUI_IS_MOBILE, tuiDefaultProp, tuiPure, AbstractTuiNullableControl, isNativeFocused, EMPTY_ARRAY, TUI_FOCUSABLE_ITEM_ACCESSOR, TuiLetModule, TuiFocusedModule, TuiFocusVisibleModule, TuiPressedModule, TuiHoveredModule, TuiFocusableModule, TuiDroppableModule, TuiPreventDefaultModule } from '@taiga-ui/cdk';
import { TUI_FILE_TEXTS, TUI_DIGITAL_INFORMATION_UNITS, TUI_INPUT_FILE_TEXTS } from '@taiga-ui/kit/tokens';
import { formatSize } from '@taiga-ui/kit/utils/files';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NgControl } from '@angular/forms';
import { TUI_MODE, MODE_PROVIDER, TuiWrapperModule, TuiSvgModule, TuiLinkModule, TuiLoaderModule, TuiButtonModule, TuiGroupModule } from '@taiga-ui/core';
import { CommonModule } from '@angular/common';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

// @dynamic
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@taiga-ui/core';
import * as ɵngcc4 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc5 from '@angular/platform-browser';
import * as ɵngcc6 from 'rxjs';
import * as ɵngcc7 from '@angular/forms';

function TuiFileOldComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiFileOldComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiFileOldComponent_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function TuiFileOldComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TuiFileOldComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("tuiFocusVisibleChange", function TuiFileOldComponent_ng_template_1_Template_a_tuiFocusVisibleChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onFocusVisible($event); });
    ɵngcc0.ɵɵtemplate(1, TuiFileOldComponent_ng_template_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("href", ctx_r2.src, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function TuiFileOldComponent_ng_template_3_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 16);
} if (rf & 2) {
    const texts_r17 = ctx.ngIf;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("alt", texts_r17.preview)("src", ctx_r9.preview, ɵngcc0.ɵɵsanitizeUrl);
} }
function TuiFileOldComponent_ng_template_3_ng_template_3_tui_loader_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-loader", 18);
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("inheritColor", ctx_r18.isBig);
} }
function TuiFileOldComponent_ng_template_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TuiFileOldComponent_ng_template_3_ng_template_3_tui_loader_0_Template, 1, 1, "tui-loader", 17);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r12 = ɵngcc0.ɵɵreference(6);
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.isLoading)("ngIfElse", _r12);
} }
function TuiFileOldComponent_ng_template_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "tui-svg", 19);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("icon_deleted", ctx_r13.isDeleted)("icon_error", ctx_r13.isError);
    ɵngcc0.ɵɵproperty("src", ctx_r13.icon);
} }
function TuiFileOldComponent_ng_template_3_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fileSize_r19 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", fileSize_r19, " ");
} }
function TuiFileOldComponent_ng_template_3_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 21);
} if (rf & 2) {
    const content_r20 = ctx.ngIf;
    ɵngcc0.ɵɵproperty("content", content_r20);
} }
function TuiFileOldComponent_ng_template_3_ng_container_17_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click.prevent", function TuiFileOldComponent_ng_template_3_ng_container_17_button_1_Template_button_click_prevent_0_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.onRemoveClick(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const texts_r22 = ctx.ngIf;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("remove_mobile", ctx_r21.isMobile);
    ɵngcc0.ɵɵproperty("title", texts_r22.remove);
} }
function TuiFileOldComponent_ng_template_3_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiFileOldComponent_ng_template_3_ng_container_17_button_1_Template, 1, 3, "button", 22);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r16.fileTexts$));
} }
function TuiFileOldComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, TuiFileOldComponent_ng_template_3_img_1_Template, 1, 2, "img", 6);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵtemplate(3, TuiFileOldComponent_ng_template_3_ng_template_3_Template, 1, 2, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, TuiFileOldComponent_ng_template_3_ng_template_5_Template, 1, 5, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵelementStart(8, "div", 10);
    ɵngcc0.ɵɵelementStart(9, "div", 11);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 12);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, TuiFileOldComponent_ng_template_3_div_13_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵpipe(14, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(15, TuiFileOldComponent_ng_template_3_div_15_Template, 1, 1, "div", 14);
    ɵngcc0.ɵɵpipe(16, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, TuiFileOldComponent_ng_template_3_ng_container_17_Template, 3, 3, "ng-container", 15);
} if (rf & 2) {
    const _r10 = ɵngcc0.ɵɵreference(4);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("preview_big", ctx_r4.isBig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.preview && ɵngcc0.ɵɵpipeBind1(2, 9, ctx_r4.fileTexts$))("ngIfElse", _r10);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.name);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.showSize && ɵngcc0.ɵɵpipeBind1(14, 11, ctx_r4.fileSize$));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(16, 13, ctx_r4.content$));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.allowDelete);
} }
const _c0 = ["input"];
function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2, "\u00A0");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "span", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const computedLabel_r6 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("content", computedLabel_r6);
} }
function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 9, 10);
    ɵngcc0.ɵɵlistener("change", function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template_input_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const texts_r8 = ctx.ngIf; const _r9 = ɵngcc0.ɵɵreference(1); const units_r3 = ɵngcc0.ɵɵnextContext(2).ngIf; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onFilesSelected(_r9, texts_r8, units_r3); })("tuiHoveredChange", function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template_input_tuiHoveredChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(4); return ctx_r13.onHovered($event); })("tuiFocusedChange", function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template_input_tuiFocusedChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r14 = ɵngcc0.ɵɵnextContext(4); return ctx_r14.onFocused($event); })("tuiPressedChange", function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template_input_tuiPressedChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r15 = ɵngcc0.ɵɵnextContext(4); return ctx_r15.onPressed($event); })("tuiDroppableDropped", function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template_input_tuiDroppableDropped_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const texts_r8 = ctx.ngIf; const units_r3 = ɵngcc0.ɵɵnextContext(2).ngIf; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onDropped($event, texts_r8, units_r3); })("tuiDroppableDragOverChange", function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template_input_tuiDroppableDragOverChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r18 = ɵngcc0.ɵɵnextContext(4); return ctx_r18.onDragOver($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("id", ctx_r7.id)("accept", ctx_r7.accept)("multiple", ctx_r7.multiple)("tuiFocusable", ctx_r7.focusable);
} }
function TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_input_1_Template, 2, 4, "input", 8);
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5.inputFileTexts$));
} }
function TuiInputFileComponent_tui_wrapper_0_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 4);
    ɵngcc0.ɵɵelementStart(1, "a", 5);
    ɵngcc0.ɵɵelement(2, "span", 6);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_4_Template, 4, 1, "ng-container", 7);
    ɵngcc0.ɵɵpipe(5, "async");
    ɵngcc0.ɵɵtemplate(6, TuiInputFileComponent_tui_wrapper_0_label_2_ng_container_6_Template, 3, 3, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("content", ɵngcc0.ɵɵpipeBind1(3, 3, ctx_r2.computedLink$));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(5, 5, ctx_r2.computedLabel$));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.readOnly && !ctx_r2.computedDisabled);
} }
function TuiInputFileComponent_tui_wrapper_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tui-wrapper", 2);
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵtemplate(2, TuiInputFileComponent_tui_wrapper_0_label_2_Template, 7, 7, "label", 3);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("wrapper_mobile", ctx_r0.isMobile)("wrapper_has-files", ctx_r0.hasFiles);
    ɵngcc0.ɵɵproperty("appearance", ctx_r0.getAppearance(ɵngcc0.ɵɵpipeBind1(1, 11, ctx_r0.mode$)))("focused", ctx_r0.computedFocused)("hovered", ctx_r0.computedHovered || ctx_r0.fileDragged)("pressed", ctx_r0.computedPressed)("readOnly", ctx_r0.readOnly)("disabled", ctx_r0.computedDisabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 13, ctx_r0.units$));
} }
function TuiInputFileComponent_section_1_tui_file_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-file", 15);
    ɵngcc0.ɵɵlistener("fileRemoved", function TuiInputFileComponent_section_1_tui_file_1_Template_tui_file_fileRemoved_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const file_r23 = ctx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.removeRejectedFile(file_r23); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r23 = ctx.$implicit;
    const mode_r19 = ɵngcc0.ɵɵnextContext().tuiLet;
    const ctx_r20 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("showSize", ctx_r20.showSize)("allowDelete", ctx_r20.interactive)("size", ctx_r20.size)("file", file_r23);
    ɵngcc0.ɵɵattribute("data-mode", mode_r19);
} }
function TuiInputFileComponent_section_1_tui_file_2_Template(rf, ctx) { if (rf & 1) {
    const _r29 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-file", 16);
    ɵngcc0.ɵɵlistener("fileRemoved", function TuiInputFileComponent_section_1_tui_file_2_Template_tui_file_fileRemoved_0_listener() { ɵngcc0.ɵɵrestoreView(_r29); const file_r27 = ctx.$implicit; const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.removeFile(file_r27); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r27 = ctx.$implicit;
    const mode_r19 = ɵngcc0.ɵɵnextContext().tuiLet;
    const ctx_r21 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("showSize", ctx_r21.showSize)("allowDelete", ctx_r21.interactive)("size", ctx_r21.size)("file", file_r27);
    ɵngcc0.ɵɵattribute("data-mode", mode_r19);
} }
function TuiInputFileComponent_section_1_tui_file_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tui-file", 17);
    ɵngcc0.ɵɵlistener("fileRemoved", function TuiInputFileComponent_section_1_tui_file_3_Template_tui_file_fileRemoved_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const file_r31 = ctx.$implicit; const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.removeFile(file_r31); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const file_r31 = ctx.$implicit;
    const mode_r19 = ɵngcc0.ɵɵnextContext().tuiLet;
    const ctx_r22 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("showSize", ctx_r22.showSize)("allowDelete", ctx_r22.interactive)("size", ctx_r22.size)("file", file_r31);
    ɵngcc0.ɵɵattribute("data-mode", mode_r19);
} }
function TuiInputFileComponent_section_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "section", 11);
    ɵngcc0.ɵɵtemplate(1, TuiInputFileComponent_section_1_tui_file_1_Template, 1, 5, "tui-file", 12);
    ɵngcc0.ɵɵtemplate(2, TuiInputFileComponent_section_1_tui_file_2_Template, 1, 5, "tui-file", 13);
    ɵngcc0.ɵɵtemplate(3, TuiInputFileComponent_section_1_tui_file_3_Template, 1, 5, "tui-file", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("collapsed", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.rejectedFiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.computedLoading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.readyFiles);
} }
let TuiFileOldComponent = class TuiFileOldComponent {
    constructor(isMobile, sanitizer, fileTexts$, units$) {
        this.isMobile = isMobile;
        this.sanitizer = sanitizer;
        this.fileTexts$ = fileTexts$;
        this.units$ = units$;
        this.file = { name: '' };
        this.state = "normal" /* Normal */;
        this.size = 'm';
        this.allowDelete = true;
        this.showSize = true;
        this.fileRemoved = new EventEmitter();
        this.focused = false;
    }
    get preview() {
        return this.isBig ? this.createPreview(this.file, this.sanitizer) : '';
    }
    get isBig() {
        return this.size === 'l';
    }
    get isLoading() {
        return this.state === "loading" /* Loading */;
    }
    get isError() {
        return this.state === "error" /* Error */;
    }
    get isDeleted() {
        return this.state === "deleted" /* Deleted */;
    }
    get icon() {
        if (this.state === "normal" /* Normal */ && this.isBig) {
            return 'tuiIconDefaultDocLarge';
        }
        switch (this.state) {
            case "deleted" /* Deleted */:
                return 'tuiIconTrashLarge';
            case "error" /* Error */:
                return 'tuiIconAlertCircleLarge';
            default:
                return 'tuiIconCheckCircleLarge';
        }
    }
    get src() {
        return this.file.src || '';
    }
    get name() {
        return this.file.name.split('.').slice(0, -1).join('.');
    }
    get type() {
        return `.${this.file.name.split('.').pop()}` || '';
    }
    get content$() {
        return this.calculateContent$(this.state, this.file, this.fileTexts$);
    }
    get fileSize$() {
        return this.calculateFileSize$(this.file, this.units$);
    }
    onRemoveClick() {
        this.fileRemoved.emit();
    }
    onFocusVisible(focusVisible) {
        this.focused = focusVisible;
    }
    calculateContent$(state, file, fileTexts$) {
        return state === "error" /* Error */ && !file.content
            ? fileTexts$.pipe(map(texts => texts.loadingError))
            : of(this.file.content || '');
    }
    calculateFileSize$(file, units$) {
        return units$.pipe(map(units => formatSize(units, file.size)));
    }
    createPreview(file, sanitizer) {
        if (file.src) {
            return file.src;
        }
        // TODO: iframe warning
        if (file instanceof File && file.type && file.type.startsWith('image/')) {
            return sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
        }
        return '';
    }
};
TuiFileOldComponent.ɵfac = function TuiFileOldComponent_Factory(t) { return new (t || TuiFileOldComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE), ɵngcc0.ɵɵdirectiveInject(DomSanitizer), ɵngcc0.ɵɵdirectiveInject(TUI_FILE_TEXTS), ɵngcc0.ɵɵdirectiveInject(TUI_DIGITAL_INFORMATION_UNITS)); };
TuiFileOldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiFileOldComponent, selectors: [["tui-file"]], hostVars: 4, hostBindings: function TuiFileOldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_focused", ctx.focused)("_link", ctx.src);
    } }, inputs: { file: "file", state: "state", size: "size", allowDelete: "allowDelete", showSize: "showSize" }, outputs: { fileRemoved: "fileRemoved" }, decls: 5, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["withLink", ""], ["fileInfoTemplate", ""], [4, "ngTemplateOutlet"], ["rel", "noreferrer noopener", "target", "_blank", 1, "link", 3, "href", "tuiFocusVisibleChange"], [1, "preview"], ["automation-id", "tui-file__preview", "class", "image", 3, "alt", "src", 4, "ngIf", "ngIfElse"], ["loader", ""], ["svg", ""], [1, "wrapper"], [1, "text"], ["automation-id", "tui-file__name", 1, "name"], ["automation-id", "tui-file__type", 1, "type"], ["automation-id", "tui-file__size", "class", "size", 4, "ngIf"], ["polymorpheus-outlet", "", "automation-id", "tui-file__content", "class", "content", 3, "content", 4, "ngIf"], [4, "ngIf"], ["automation-id", "tui-file__preview", 1, "image", 3, "alt", "src"], ["automation-id", "tui-file__loader", "class", "loader", 3, "inheritColor", 4, "ngIf", "ngIfElse"], ["automation-id", "tui-file__loader", 1, "loader", 3, "inheritColor"], ["automation-id", "tui-file__icon", 1, "icon", 3, "src"], ["automation-id", "tui-file__size", 1, "size"], ["polymorpheus-outlet", "", "automation-id", "tui-file__content", 1, "content", 3, "content"], ["automation-id", "tui-file__remove", "tuiIconButton", "", "type", "button", "size", "xs", "icon", "tuiIconCloseLarge", "appearance", "icon", "class", "remove", 3, "title", "remove_mobile", "click.prevent", 4, "ngIf"], ["automation-id", "tui-file__remove", "tuiIconButton", "", "type", "button", "size", "xs", "icon", "tuiIconCloseLarge", "appearance", "icon", 1, "remove", 3, "title", "click.prevent"]], template: function TuiFileOldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiFileOldComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TuiFileOldComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, TuiFileOldComponent_ng_template_3_Template, 18, 15, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.src)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.TuiFocusVisibleDirective, ɵngcc3.TuiLoaderComponent, ɵngcc3.TuiSvgComponent, ɵngcc4.PolymorpheusOutletComponent, ɵngcc3.TuiButtonComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{position:relative;display:flex;font:var(--tui-font-text-m);border:1px solid var(--tui-base-03);border-radius:var(--tui-radius-m)}[data-mode=onDark][_nghost-%COMP%]{color:var(--tui-text-01-night)}[_nghost-%COMP%]:not(._link){padding:.5625rem 2.1875rem .5625rem .5625rem}[_nghost-%COMP%]:hover   .remove[_ngcontent-%COMP%]{opacity:1}._focused[_nghost-%COMP%]{border-color:var(--tui-focus);box-shadow:0 0 0 1px inset var(--tui-focus)}.link[_ngcontent-%COMP%]{display:flex;flex:1;padding:.5625rem 2.1875rem .5625rem .5625rem;text-decoration:none;outline:0;cursor:pointer;color:var(--tui-text-01);max-width:calc(100% - 2.75rem)}.link[_ngcontent-%COMP%]:hover{background-color:var(--tui-base-02)}.preview[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:1.5rem;height:1.5rem;margin-right:.75rem;border-radius:var(--tui-radius-m);overflow:hidden;color:rgba(0,0,0,.24)}.preview_big[_ngcontent-%COMP%]{width:4rem;height:4rem;margin-right:1rem}.preview_big[_ngcontent-%COMP%]:before{position:absolute;top:0;left:0;width:100%;height:100%;content:'';background:#333;opacity:.08}.image[_ngcontent-%COMP%]{max-width:100%;max-height:100%}.loader[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%}.icon[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;color:var(--tui-success-fill)}.icon_error[_ngcontent-%COMP%]{color:var(--tui-error-fill)}.icon_deleted[_ngcontent-%COMP%]{color:var(--tui-base-06)}.remove[_ngcontent-%COMP%]{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:absolute;top:.625rem;right:.625rem;opacity:0}.remove[_ngcontent-%COMP%]:focus, .remove_mobile[_ngcontent-%COMP%]{opacity:1}.wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;overflow:hidden}.text[_ngcontent-%COMP%]{display:flex}.size[_ngcontent-%COMP%]{flex-shrink:0;opacity:var(--tui-disabled-opacity);margin-left:.5rem}.type[_ngcontent-%COMP%]{flex-shrink:0}.name[_ngcontent-%COMP%]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.content[_ngcontent-%COMP%]{font:var(--tui-font-text-s);color:var(--tui-error-fill)}"], changeDetection: 0 });
TuiFileOldComponent.ctorParameters = () => [
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_MOBILE,] }] },
    { type: DomSanitizer, decorators: [{ type: Inject, args: [DomSanitizer,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_FILE_TEXTS,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_DIGITAL_INFORMATION_UNITS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiFileOldComponent.prototype, "file", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiFileOldComponent.prototype, "state", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiFileOldComponent.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiFileOldComponent.prototype, "allowDelete", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiFileOldComponent.prototype, "showSize", void 0);
__decorate([
    Output()
], TuiFileOldComponent.prototype, "fileRemoved", void 0);
__decorate([
    HostBinding('class._focused')
], TuiFileOldComponent.prototype, "focused", void 0);
__decorate([
    HostBinding('class._link')
], TuiFileOldComponent.prototype, "src", null);
__decorate([
    tuiPure
], TuiFileOldComponent.prototype, "calculateContent$", null);
__decorate([
    tuiPure
], TuiFileOldComponent.prototype, "calculateFileSize$", null);
__decorate([
    tuiPure
], TuiFileOldComponent.prototype, "createPreview", null);
TuiFileOldComponent = __decorate([ __param(0, Inject(TUI_IS_MOBILE)),
    __param(1, Inject(DomSanitizer)),
    __param(2, Inject(TUI_FILE_TEXTS)),
    __param(3, Inject(TUI_DIGITAL_INFORMATION_UNITS))
], TuiFileOldComponent);

var TuiInputFileComponent_1;
const DEFAULT_MAX_SIZE = 30 * 1000 * 1000; // 30 MB
// @dynamic
let TuiInputFileComponent = TuiInputFileComponent_1 = class TuiInputFileComponent extends AbstractTuiNullableControl {
    constructor(control, changeDetectorRef, isMobile, inputFileTexts$, mode$, units$) {
        super(control, changeDetectorRef);
        this.isMobile = isMobile;
        this.inputFileTexts$ = inputFileTexts$;
        this.mode$ = mode$;
        this.units$ = units$;
        this.dataTransfer = null;
        this.link = '';
        this.label = '';
        this.accept = '';
        this.multiple = false;
        this.size = 'm';
        this.showSize = true;
        this.maxFileSize = DEFAULT_MAX_SIZE;
        this.loadingFiles = [];
        this.rejectedFiles = [];
        this.rejectedFilesChange = new EventEmitter();
    }
    get nativeFocusableElement() {
        return this.input ? this.input.nativeElement : null;
    }
    get focused() {
        return isNativeFocused(this.nativeFocusableElement);
    }
    get computedLink$() {
        return this.computeLink$(this.fileDragged, this.multiple, this.link);
    }
    get computedLabel$() {
        return this.computeLabel$(this.isMobile, this.fileDragged, this.multiple, this.label);
    }
    // @bad TODO: refactor after IE is dropped
    get fileDragged() {
        return (!!this.dataTransfer &&
            Array.prototype.indexOf.call(this.dataTransfer.types, 'Files') !== -1);
    }
    get acceptArray() {
        return this.getAcceptArray(this.accept);
    }
    get arrayValue() {
        return this.getValueArray(this.value);
    }
    get readyFiles() {
        return this.getReadyFiles(this.arrayValue, this.loadingFiles);
    }
    get computedLoading() {
        return this.getLoadingFiles(this.arrayValue, this.loadingFiles);
    }
    get hasFiles() {
        return !!this.rejectedFiles.length || !!this.arrayValue.length;
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onFocused(focused) {
        this.updateFocused(focused);
    }
    onPressed(pressed) {
        this.updatePressed(pressed);
    }
    // TODO: refactor i18n messages
    onFilesSelected(input, texts, units) {
        this.processSelectedFiles(input.files, texts, units);
        input.value = '';
    }
    onDropped(event, texts, units) {
        this.processSelectedFiles(event.files, texts, units);
    }
    onDragOver(dataTransfer) {
        this.dataTransfer = dataTransfer;
    }
    removeFile(removedFile) {
        this.updateValue(this.multiple ? this.arrayValue.filter(file => file !== removedFile) : null);
    }
    removeRejectedFile(removedFile) {
        this.updateRejectedFiles(this.rejectedFiles.filter(file => file !== removedFile));
    }
    getAppearance(mode) {
        return mode === null ? '' : "outline" /* Outline */;
    }
    computeLink$(fileDragged, multiple, link) {
        if (fileDragged) {
            return of('');
        }
        return this.inputFileTexts$.pipe(map(texts => multiple && link === ''
            ? texts.defaultLinkMultiple
            : link || texts.defaultLinkSingle));
    }
    computeLabel$(isMobile, fileDragged, multiple, label) {
        if (isMobile) {
            return of('');
        }
        if (fileDragged) {
            return this.inputFileTexts$.pipe(map(texts => (multiple ? texts.dropMultiple : texts.drop)));
        }
        return this.inputFileTexts$.pipe(map(texts => multiple && label === ''
            ? texts.defaultLabelMultiple
            : label || texts.defaultLabelSingle));
    }
    getValueArray(value) {
        if (!value) {
            return EMPTY_ARRAY;
        }
        return value instanceof Array ? value : [value];
    }
    getReadyFiles(value, loading) {
        return value.filter(file => !loading.includes(file));
    }
    getLoadingFiles(value, loading) {
        return loading.filter(file => value.includes(file));
    }
    getAcceptArray(accept) {
        return accept
            .toLowerCase()
            .split(',')
            .map(format => format.trim());
    }
    processSelectedFiles(files, texts, units) {
        // IE11 after selecting a file through the open dialog generates a second event passing an empty FileList.
        if (files === null || files.length === 0) {
            return;
        }
        const newFiles = this.multiple ? Array.from(files) : [files[0]];
        const tooBigFiles = newFiles.filter(file => file.size > this.maxFileSize);
        const wrongFormatFiles = newFiles.filter(file => !this.isFormatAcceptable(file) && !tooBigFiles.includes(file));
        const acceptedFiles = newFiles.filter(file => !tooBigFiles.includes(file) && !wrongFormatFiles.includes(file));
        this.updateRejectedFiles([
            ...tooBigFiles.map(file => ({
                name: file.name,
                type: file.type,
                size: file.size,
                content: texts.maxSizeRejectionReason + formatSize(units, this.maxFileSize),
            })),
            ...wrongFormatFiles.map(file => ({
                name: file.name,
                type: file.type,
                size: file.size,
                content: texts.formatRejectionReason,
            })),
        ]);
        this.updateValue(this.multiple
            ? [...this.arrayValue, ...acceptedFiles]
            : acceptedFiles[0] || null);
    }
    isFormatAcceptable(file) {
        if (!this.accept) {
            return true;
        }
        const extension = `.${(file.name.split('.').pop() || '').toLowerCase()}`;
        return this.acceptArray.some(format => format === extension ||
            format === file.type ||
            (format.split('/')[1] === '*' &&
                file.type.split('/')[0] === format.split('/')[0]));
    }
    updateRejectedFiles(rejectedFiles) {
        this.rejectedFiles = rejectedFiles;
        this.rejectedFilesChange.emit(rejectedFiles);
    }
};
TuiInputFileComponent.ɵfac = function TuiInputFileComponent_Factory(t) { return new (t || TuiInputFileComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE), ɵngcc0.ɵɵdirectiveInject(TUI_INPUT_FILE_TEXTS), ɵngcc0.ɵɵdirectiveInject(TUI_MODE), ɵngcc0.ɵɵdirectiveInject(TUI_DIGITAL_INFORMATION_UNITS)); };
TuiInputFileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TuiInputFileComponent, selectors: [["tui-input-file"]], viewQuery: function TuiInputFileComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, inputs: { link: "link", label: "label", accept: "accept", multiple: "multiple", size: "size", showSize: "showSize", maxFileSize: "maxFileSize", loadingFiles: "loadingFiles", rejectedFiles: "rejectedFiles" }, outputs: { rejectedFilesChange: "rejectedFilesChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            MODE_PROVIDER,
            {
                provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                useExisting: forwardRef(() => TuiInputFileComponent_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [["class", "wrapper", 3, "wrapper_mobile", "wrapper_has-files", "appearance", "focused", "hovered", "pressed", "readOnly", "disabled", 4, "ngIf"], ["tuiGroup", "", "orientation", "vertical", "class", "files", 3, "collapsed", 4, "tuiLet"], [1, "wrapper", 3, "appearance", "focused", "hovered", "pressed", "readOnly", "disabled"], ["automation-id", "tui-input-file__label", 4, "ngIf"], ["automation-id", "tui-input-file__label"], ["tuiLink", ""], ["polymorpheus-outlet", "", 1, "inline", 3, "content"], [4, "ngIf"], ["type", "file", "tuiPreventDefault", "mousedown", "class", "native", 3, "id", "accept", "multiple", "tuiFocusable", "change", "tuiHoveredChange", "tuiFocusedChange", "tuiPressedChange", "tuiDroppableDropped", "tuiDroppableDragOverChange", 4, "ngIf"], ["type", "file", "tuiPreventDefault", "mousedown", 1, "native", 3, "id", "accept", "multiple", "tuiFocusable", "change", "tuiHoveredChange", "tuiFocusedChange", "tuiPressedChange", "tuiDroppableDropped", "tuiDroppableDragOverChange"], ["input", ""], ["tuiGroup", "", "orientation", "vertical", 1, "files", 3, "collapsed"], ["automation-id", "tui-input-file__error", "state", "error", 3, "showSize", "allowDelete", "size", "file", "fileRemoved", 4, "ngFor", "ngForOf"], ["automation-id", "tui-input-file__loading", "state", "loading", 3, "showSize", "allowDelete", "size", "file", "fileRemoved", 4, "ngFor", "ngForOf"], ["automation-id", "tui-input-file__file", 3, "showSize", "allowDelete", "size", "file", "fileRemoved", 4, "ngFor", "ngForOf"], ["automation-id", "tui-input-file__error", "state", "error", 3, "showSize", "allowDelete", "size", "file", "fileRemoved"], ["automation-id", "tui-input-file__loading", "state", "loading", 3, "showSize", "allowDelete", "size", "file", "fileRemoved"], ["automation-id", "tui-input-file__file", 3, "showSize", "allowDelete", "size", "file", "fileRemoved"]], template: function TuiInputFileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiInputFileComponent_tui_wrapper_0_Template, 4, 15, "tui-wrapper", 0);
        ɵngcc0.ɵɵtemplate(1, TuiInputFileComponent_section_1_Template, 4, 4, "section", 1);
        ɵngcc0.ɵɵpipe(2, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.multiple || !ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("tuiLet", ɵngcc0.ɵɵpipeBind1(2, 2, ctx.mode$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.TuiLetDirective, ɵngcc3.TuiWrapperDirective, ɵngcc3.TuiLinkComponent, ɵngcc4.PolymorpheusOutletComponent, ɵngcc2.TuiPreventDefaultDirective, ɵngcc2.TuiFocusableDirective, ɵngcc2.TuiHoveredDirective, ɵngcc2.TuiFocusedDirective, ɵngcc2.TuiPressedDirective, ɵngcc2.TuiDroppableDirective, ɵngcc3.TuiGroupDirective, ɵngcc1.NgForOf, TuiFileOldComponent], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{display:block;font:var(--tui-font-text-m);word-wrap:break-word;color:var(--tui-text-02)}.native[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer}.native[_ngcontent-%COMP%]::-webkit-file-upload-button{display:none}.inline[_ngcontent-%COMP%]{display:inline}.wrapper[_ngcontent-%COMP%]{display:flex;flex:1;justify-content:center;align-items:center;min-height:var(--tui-height-l);border-radius:var(--tui-radius-m);padding:1rem .5rem;box-sizing:border-box}.wrapper[_ngcontent-%COMP%]:after{border:1px dashed;color:var(--tui-link)}.wrapper_mobile[_ngcontent-%COMP%]:after{border-style:solid}.wrapper_has-files[_ngcontent-%COMP%]{margin-bottom:.5rem}.wrapper[data-state=hovered][_ngcontent-%COMP%]{background:var(--tui-secondary)}.wrapper[data-state=hovered][_ngcontent-%COMP%]:after{color:var(--tui-link-hover)}.wrapper[data-state=pressed][_ngcontent-%COMP%]{background:var(--tui-secondary-hover)}.wrapper[data-state=readonly][_ngcontent-%COMP%]{pointer-events:none}.wrapper[data-state=readonly][_ngcontent-%COMP%]:after{color:var(--tui-text-03)}.wrapper[data-state=disabled][_ngcontent-%COMP%]{opacity:var(--tui-disabled-opacity);pointer-events:none}.wrapper[data-state=disabled][_ngcontent-%COMP%]:after{color:var(--tui-text-03)}.wrapper._focused[_ngcontent-%COMP%]:after{border-style:solid;border-width:2px;color:var(--tui-focus)}.files[_ngcontent-%COMP%]{display:flex}"], changeDetection: 0 });
TuiInputFileComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_MOBILE,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_INPUT_FILE_TEXTS,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_MODE,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_DIGITAL_INFORMATION_UNITS,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "link", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "label", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "accept", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "multiple", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "size", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "showSize", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "maxFileSize", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "loadingFiles", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputFileComponent.prototype, "rejectedFiles", void 0);
__decorate([
    Output()
], TuiInputFileComponent.prototype, "rejectedFilesChange", void 0);
__decorate([
    ViewChild('input')
], TuiInputFileComponent.prototype, "input", void 0);
__decorate([
    tuiPure
], TuiInputFileComponent.prototype, "computeLink$", null);
__decorate([
    tuiPure
], TuiInputFileComponent.prototype, "computeLabel$", null);
__decorate([
    tuiPure
], TuiInputFileComponent.prototype, "getValueArray", null);
__decorate([
    tuiPure
], TuiInputFileComponent.prototype, "getReadyFiles", null);
__decorate([
    tuiPure
], TuiInputFileComponent.prototype, "getLoadingFiles", null);
__decorate([
    tuiPure
], TuiInputFileComponent.prototype, "getAcceptArray", null);
TuiInputFileComponent = TuiInputFileComponent_1 = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef)),
    __param(2, Inject(TUI_IS_MOBILE)),
    __param(3, Inject(TUI_INPUT_FILE_TEXTS)),
    __param(4, Inject(TUI_MODE)),
    __param(5, Inject(TUI_DIGITAL_INFORMATION_UNITS))
], TuiInputFileComponent);

let TuiInputFileModule = class TuiInputFileModule {
};
TuiInputFileModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiInputFileModule });
TuiInputFileModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiInputFileModule_Factory(t) { return new (t || TuiInputFileModule)(); }, imports: [[
            CommonModule,
            PolymorpheusModule,
            TuiLetModule,
            TuiFocusedModule,
            TuiFocusVisibleModule,
            TuiPressedModule,
            TuiHoveredModule,
            TuiFocusableModule,
            TuiDroppableModule,
            TuiWrapperModule,
            TuiSvgModule,
            TuiLinkModule,
            TuiLoaderModule,
            TuiButtonModule,
            TuiPreventDefaultModule,
            TuiGroupModule,
        ]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiFileOldComponent, [{
        type: Component,
        args: [{
                selector: 'tui-file',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: "<ng-container *ngIf=\"!src; else withLink\">\n    <ng-container *ngTemplateOutlet=\"fileInfoTemplate\"></ng-container>\n</ng-container>\n\n<ng-template #withLink>\n    <a\n        rel=\"noreferrer noopener\"\n        target=\"_blank\"\n        class=\"link\"\n        [href]=\"src\"\n        (tuiFocusVisibleChange)=\"onFocusVisible($event)\"\n    >\n        <ng-container *ngTemplateOutlet=\"fileInfoTemplate\"></ng-container>\n    </a>\n</ng-template>\n\n<ng-template #fileInfoTemplate>\n    <div class=\"preview\" [class.preview_big]=\"isBig\">\n        <img\n            *ngIf=\"preview && (fileTexts$ | async) as texts; else loader\"\n            automation-id=\"tui-file__preview\"\n            class=\"image\"\n            [alt]=\"texts.preview\"\n            [src]=\"preview\"\n        />\n        <ng-template #loader>\n            <tui-loader\n                *ngIf=\"isLoading; else svg\"\n                automation-id=\"tui-file__loader\"\n                class=\"loader\"\n                [inheritColor]=\"isBig\"\n            ></tui-loader>\n        </ng-template>\n        <ng-template #svg>\n            <tui-svg\n                automation-id=\"tui-file__icon\"\n                class=\"icon\"\n                [class.icon_deleted]=\"isDeleted\"\n                [class.icon_error]=\"isError\"\n                [src]=\"icon\"\n            ></tui-svg>\n        </ng-template>\n    </div>\n    <div class=\"wrapper\">\n        <div class=\"text\">\n            <div automation-id=\"tui-file__name\" class=\"name\">{{ name }}</div>\n            <div automation-id=\"tui-file__type\" class=\"type\">{{ type }}</div>\n            <div\n                *ngIf=\"showSize && (fileSize$ | async) as fileSize\"\n                automation-id=\"tui-file__size\"\n                class=\"size\"\n            >\n                {{ fileSize }}\n            </div>\n        </div>\n        <div\n            *ngIf=\"content$ | async as content\"\n            polymorpheus-outlet\n            automation-id=\"tui-file__content\"\n            class=\"content\"\n            [content]=\"content\"\n        ></div>\n    </div>\n    <ng-container *ngIf=\"allowDelete\">\n        <button\n            *ngIf=\"fileTexts$ | async as texts\"\n            automation-id=\"tui-file__remove\"\n            tuiIconButton\n            type=\"button\"\n            size=\"xs\"\n            icon=\"tuiIconCloseLarge\"\n            appearance=\"icon\"\n            class=\"remove\"\n            [title]=\"texts.remove\"\n            [class.remove_mobile]=\"isMobile\"\n            (click.prevent)=\"onRemoveClick()\"\n        ></button>\n    </ng-container>\n</ng-template>\n",
                styles: [":host{position:relative;display:flex;font:var(--tui-font-text-m);border:1px solid var(--tui-base-03);border-radius:var(--tui-radius-m)}:host[data-mode=onDark]{color:var(--tui-text-01-night)}:host:not(._link){padding:.5625rem 2.1875rem .5625rem .5625rem}:host:hover .remove{opacity:1}:host._focused{border-color:var(--tui-focus);box-shadow:0 0 0 1px inset var(--tui-focus)}.link{display:flex;flex:1;padding:.5625rem 2.1875rem .5625rem .5625rem;text-decoration:none;outline:0;cursor:pointer;color:var(--tui-text-01);max-width:calc(100% - 2.75rem)}.link:hover{background-color:var(--tui-base-02)}.preview{position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:1.5rem;height:1.5rem;margin-right:.75rem;border-radius:var(--tui-radius-m);overflow:hidden;color:rgba(0,0,0,.24)}.preview_big{width:4rem;height:4rem;margin-right:1rem}.preview_big:before{position:absolute;top:0;left:0;width:100%;height:100%;content:'';background:#333;opacity:.08}.image{max-width:100%;max-height:100%}.loader{position:absolute;top:0;left:0;width:100%;height:100%}.icon{position:absolute;top:0;left:0;width:100%;height:100%;color:var(--tui-success-fill)}.icon_error{color:var(--tui-error-fill)}.icon_deleted{color:var(--tui-base-06)}.remove{transition-property:opacity;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:absolute;top:.625rem;right:.625rem;opacity:0}.remove:focus,.remove_mobile{opacity:1}.wrapper{display:flex;flex-direction:column;justify-content:center;overflow:hidden}.text{display:flex}.size{flex-shrink:0;opacity:var(--tui-disabled-opacity);margin-left:.5rem}.type{flex-shrink:0}.name{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.content{font:var(--tui-font-text-s);color:var(--tui-error-fill)}"]
            }]
    }], function () { return [{ type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE]
            }] }, { type: ɵngcc5.DomSanitizer, decorators: [{
                type: Inject,
                args: [DomSanitizer]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_FILE_TEXTS]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_DIGITAL_INFORMATION_UNITS]
            }] }]; }, { file: [{
            type: Input
        }], state: [{
            type: Input
        }], size: [{
            type: Input
        }], allowDelete: [{
            type: Input
        }], showSize: [{
            type: Input
        }], fileRemoved: [{
            type: Output
        }], focused: [{
            type: HostBinding,
            args: ['class._focused']
        }], src: [{
            type: HostBinding,
            args: ['class._link']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiInputFileComponent, [{
        type: Component,
        args: [{
                selector: 'tui-input-file',
                template: "<tui-wrapper\n    *ngIf=\"multiple || !value\"\n    class=\"wrapper\"\n    [class.wrapper_mobile]=\"isMobile\"\n    [class.wrapper_has-files]=\"hasFiles\"\n    [appearance]=\"getAppearance(mode$ | async)\"\n    [focused]=\"computedFocused\"\n    [hovered]=\"computedHovered || fileDragged\"\n    [pressed]=\"computedPressed\"\n    [readOnly]=\"readOnly\"\n    [disabled]=\"computedDisabled\"\n>\n    <label\n        *ngIf=\"units$ | async as units\"\n        automation-id=\"tui-input-file__label\"\n    >\n        <a tuiLink>\n            <span\n                polymorpheus-outlet\n                class=\"inline\"\n                [content]=\"computedLink$ | async\"\n            ></span>\n        </a>\n        <ng-container *ngIf=\"computedLabel$ | async as computedLabel\">\n            <span>&nbsp;</span>\n            <span\n                polymorpheus-outlet\n                class=\"inline\"\n                [content]=\"computedLabel\"\n            ></span>\n        </ng-container>\n        <ng-container *ngIf=\"!readOnly && !computedDisabled\">\n            <input\n                *ngIf=\"inputFileTexts$ | async as texts\"\n                #input\n                type=\"file\"\n                tuiPreventDefault=\"mousedown\"\n                class=\"native\"\n                [id]=\"id\"\n                [accept]=\"accept\"\n                [multiple]=\"multiple\"\n                [tuiFocusable]=\"focusable\"\n                (change)=\"onFilesSelected(input, texts, units)\"\n                (tuiHoveredChange)=\"onHovered($event)\"\n                (tuiFocusedChange)=\"onFocused($event)\"\n                (tuiPressedChange)=\"onPressed($event)\"\n                (tuiDroppableDropped)=\"onDropped($event, texts, units)\"\n                (tuiDroppableDragOverChange)=\"onDragOver($event)\"\n            />\n        </ng-container>\n    </label>\n</tui-wrapper>\n\n<section\n    *tuiLet=\"mode$ | async as mode\"\n    tuiGroup\n    orientation=\"vertical\"\n    class=\"files\"\n    [collapsed]=\"true\"\n>\n    <tui-file\n        *ngFor=\"let file of rejectedFiles\"\n        automation-id=\"tui-input-file__error\"\n        state=\"error\"\n        [attr.data-mode]=\"mode\"\n        [showSize]=\"showSize\"\n        [allowDelete]=\"interactive\"\n        [size]=\"size\"\n        [file]=\"file\"\n        (fileRemoved)=\"removeRejectedFile(file)\"\n    ></tui-file>\n    <tui-file\n        *ngFor=\"let file of computedLoading\"\n        automation-id=\"tui-input-file__loading\"\n        state=\"loading\"\n        [attr.data-mode]=\"mode\"\n        [showSize]=\"showSize\"\n        [allowDelete]=\"interactive\"\n        [size]=\"size\"\n        [file]=\"file\"\n        (fileRemoved)=\"removeFile(file)\"\n    ></tui-file>\n    <tui-file\n        *ngFor=\"let file of readyFiles\"\n        automation-id=\"tui-input-file__file\"\n        [attr.data-mode]=\"mode\"\n        [showSize]=\"showSize\"\n        [allowDelete]=\"interactive\"\n        [size]=\"size\"\n        [file]=\"file\"\n        (fileRemoved)=\"removeFile(file)\"\n    ></tui-file>\n</section>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    MODE_PROVIDER,
                    {
                        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
                        useExisting: forwardRef(() => TuiInputFileComponent_1)
                    },
                ],
                styles: [":host{display:block;font:var(--tui-font-text-m);word-wrap:break-word;color:var(--tui-text-02)}.native{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer}.native::-webkit-file-upload-button{display:none}.inline{display:inline}.wrapper{display:flex;flex:1;justify-content:center;align-items:center;min-height:var(--tui-height-l);border-radius:var(--tui-radius-m);padding:1rem .5rem;box-sizing:border-box}.wrapper:after{border:1px dashed;color:var(--tui-link)}.wrapper_mobile:after{border-style:solid}.wrapper_has-files{margin-bottom:.5rem}.wrapper[data-state=hovered]{background:var(--tui-secondary)}.wrapper[data-state=hovered]:after{color:var(--tui-link-hover)}.wrapper[data-state=pressed]{background:var(--tui-secondary-hover)}.wrapper[data-state=readonly]{pointer-events:none}.wrapper[data-state=readonly]:after{color:var(--tui-text-03)}.wrapper[data-state=disabled]{opacity:var(--tui-disabled-opacity);pointer-events:none}.wrapper[data-state=disabled]:after{color:var(--tui-text-03)}.wrapper._focused:after{border-style:solid;border-width:2px;color:var(--tui-focus)}.files{display:flex}"]
            }]
    }], function () { return [{ type: ɵngcc7.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_INPUT_FILE_TEXTS]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_MODE]
            }] }, { type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_DIGITAL_INFORMATION_UNITS]
            }] }]; }, { link: [{
            type: Input
        }], label: [{
            type: Input
        }], accept: [{
            type: Input
        }], multiple: [{
            type: Input
        }], size: [{
            type: Input
        }], showSize: [{
            type: Input
        }], maxFileSize: [{
            type: Input
        }], loadingFiles: [{
            type: Input
        }], rejectedFiles: [{
            type: Input
        }], rejectedFilesChange: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['input']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiInputFileModule, { declarations: function () { return [TuiFileOldComponent, TuiInputFileComponent]; }, imports: function () { return [CommonModule,
        PolymorpheusModule,
        TuiLetModule,
        TuiFocusedModule,
        TuiFocusVisibleModule,
        TuiPressedModule,
        TuiHoveredModule,
        TuiFocusableModule,
        TuiDroppableModule,
        TuiWrapperModule,
        TuiSvgModule,
        TuiLinkModule,
        TuiLoaderModule,
        TuiButtonModule,
        TuiPreventDefaultModule,
        TuiGroupModule]; }, exports: function () { return [TuiInputFileComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiInputFileModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PolymorpheusModule,
                    TuiLetModule,
                    TuiFocusedModule,
                    TuiFocusVisibleModule,
                    TuiPressedModule,
                    TuiHoveredModule,
                    TuiFocusableModule,
                    TuiDroppableModule,
                    TuiWrapperModule,
                    TuiSvgModule,
                    TuiLinkModule,
                    TuiLoaderModule,
                    TuiButtonModule,
                    TuiPreventDefaultModule,
                    TuiGroupModule,
                ],
                declarations: [TuiFileOldComponent, TuiInputFileComponent],
                exports: [TuiInputFileComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiFileOldComponent, TuiInputFileComponent, TuiInputFileModule };

//# sourceMappingURL=taiga-ui-kit-components-input-file.js.map